import React, { useContext,useCallback, useEffect, useRef, useState } from 'react'
import PageTitle from '../../Components/PageTitle'
import { NavLink, useLocation } from 'react-router-dom'
import { currentDateAndTime, decodeData, formatDateAndTime, formatDateWithTime, } from '../../Constants/constants'
import Swal from 'sweetalert2'
import { ConfigContext } from '../../Context/ConfigContext'
import axios from 'axios'

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import copy from 'clipboard-copy';
import { formatDate, TextBox } from '../../Components/InputElements'
import { NoRecords } from '../../Components/Shimmer'

const Resignation = () => {
    const { apiURL, apiHeaderFile, apiHeaderJSON,employee_id,permissions } = useContext(ConfigContext);
    const locationParam = useLocation();
    const queryParams = new URLSearchParams(locationParam.search);
    const encodedData = queryParams.get("abs");
    const decodedData = decodeData(encodedData, permissions);

    const [rows, setRows] = useState([]);
    const [logRows, setLogRows] = useState([]);
    const [canSend, setCanSend] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadingLogs, setLoadingLogs] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const [viewResignationLogs, setViewResignationLogs] = useState(false);
    const [fnfSettings, setFnfSettings] = useState(false);
    const [applyButton, setApplyButton] = useState(false);
    const [errors, setErrors] = useState({});
    const [modals,setModals]=useState({
        applyModal:false,
        viewDocument: false,
    })
  const [employeeResignationData, setEmployeeResignationData] = useState(
    [
    {
        applyDate: '2025-01-16',
        mailSubject: 'Resignation',
        mailBody: `<p>Dear Sir,</p><p>&nbsp;</p><p>I hope this message finds you well.</p><p>&nbsp;</p>
        <p>I am writing to formally resign from my position as <strong>##designation##</strong> 
        (Employee ID: <strong>##employee_code##</strong>).</p><p>It has been a pleasure working 
        with the team, and I am grateful for the support and opportunities provided during my tenure.</p>
        <p>Please let me know if there are any formalities or handover processes I need to complete before 
        my departure.</p><p>Thank you for your understanding and guidance.</p><p>&nbsp;</p><p>Best regards,
        <br><strong>##employee_name##</strong></p>`,
        status:"Applied",
    },
    ]);
  const [formData, setFormData] = useState({
    mailTemplateTitle: '',
    mailSubject: 'Resignation',
    mailBody: `<p>Dear Sir,</p><p>&nbsp;</p><p>I hope this message finds you well.</p><p>&nbsp;</p>
    <p>I am writing to formally resign from my position as <strong>##designation##</strong> 
    (Employee ID: <strong>##employee_code##</strong>).</p><p>It has been a pleasure working 
    with the team, and I am grateful for the support and opportunities provided during my tenure.</p>
    <p>Please let me know if there are any formalities or handover processes I need to complete before 
    my departure.</p><p>Thank you for your understanding and guidance.</p><p>&nbsp;</p><p>Best regards,
    <br><strong>##employee_name##</strong></p>`,
    file:null,
    fileData:null,
    requestedRelievingDate:null,
  });
  const [employeeBasicData, setEmployeeBasicData] = useState({});


  const handleInputChange = (name, value) => {
    // console.log(name, value)
    setFormData({ ...formData, [name]: value })
    setErrors({ ...errors, [name]: '' })
  }

  const debounceTimerRef = useRef(null);
  const [editorContent, setEditorContent] = useState(formData?.mailBody || "");

  // 🛑 Debounced function to update formData after user stops typing
  const updateMailBody = useCallback((content) => {
    setFormData((prevState) => ({
      ...prevState,
      mailBody: content,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      mailBody: "",
    }));
  }, [setFormData, setErrors]);

  // 🔄 Handle editor input with debouncing
  const handleEditorChange = (content) => {
    setEditorContent(content); // Update local state immediately

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    debounceTimerRef.current = setTimeout(() => {
      updateMailBody(content);
    }, 1000);
  };

  // ✅ Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const getList = () => {
    setLoading(true);
    let options = { 
        url: `${apiURL}ResignationRouter/GetMyResignation`,
        method: "GET",
        headers: apiHeaderJSON,
    }
    axios(options)
        .then((response) => {
            // console.log("GetMyResignation ~ response", response?.data);
            let data = response?.data
            if (response.data.success === true) {
                setRows(data?.data);
                setApplyButton(data?.show_apply_button);
            }

            setLoading(false);
        })
        .catch((e) => {
            console.error(e);
            setLoading(false);
        });

}

useEffect(()=>{
    console.log("formData?.mailBody",formData?.mailBody);
},[formData?.mailBody])

  const getUser = () => {
    setLoading(true);
    let options = {
        url: `${apiURL}Home/GetProfile?employee_id=${employee_id}`,
        method: "GET",
        headers: apiHeaderJSON,
    }
    axios(options)
        .then((response) => {
            // console.log("getUser ~ response", response?.data);
            let res = response?.data?.data
            if (response.data.success === true) {
                setEmployeeBasicData(res?.employee);
                setIsChanged(true);
                setFormData({
                    ...formData,
                    mailSubject: `Resignation Of ${res?.employee?.employee_name || ''} ${res?.employee?.employee_code?`(${res?.employee?.employee_code})`:''}`
                });
                setEmployeeResignationData([
                    {
                    ...employeeResignationData[0],
                    mailSubject: `Resignation Of ${res?.employee?.employee_name || ''} ${res?.employee?.employee_code?`(${res?.employee?.employee_code})`:''}`
                    }
                ]);
            }

            setLoading(false);
        })
        .catch((e) => {
            console.error(e);
            setLoading(false);
        });

}

const getFnfSettings = () => {
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}ResignationRouter/GetFNFSettings`, 
        {params: { 
            date: currentDateAndTime()
        },
         headers 
        })
        .then((response) => {
            const data = response.data;
            console.info("GetFNFSettings",data);
            if (response.data.success === true) {
                setFnfSettings(Array.isArray(data.data) && data.data.length>0 ? data.data[0]:{});
            }
        });
}
const getLogs = (row) => {
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}ResignationRouter/GetMyResignationLog`, 
        {params: { 
            date: currentDateAndTime(),
            employee_resignation_id: row?.employee_resignation_id,
        },
         headers 
        })
        .then((response) => {
            const data = response.data;
            console.info("GetMyResignationLog",data);
            if (response.data.success === true) {
                setViewResignationLogs(true);
                setLogRows(Array.isArray(data.data) && data.data.length>0 ? data.data:[]);
                if(Array.isArray(data.data) && data.data.length>0){
                    setFormData({
                        ...formData,
                        mailSubject: data.data[0]?.email_subject,
                        requestedRelievingDate: data.data[data.data?.length-1]?.request_last_working_date,
                    });
                    setFnfSettings({
                        ...fnfSettings,
                        notice_period_duration:data.data[0]?.notice_period,
                        last_working_date: data.data[0]?.last_working_date,
                    })
                }else{
                    setFormData({
                        ...formData,
                        mailSubject: "",
                        requestedRelievingDate: "",
                    });
                    setFnfSettings({
                        ...fnfSettings,
                        notice_period_duration:"",
                        last_working_date: "",
                    })
                }
                setFnfSettings({
                    ...fnfSettings,
                    notice_period_duration:row?.notice_period,
                    last_working_date: row?.last_working_date,
                })
            }
            else{
                Swal.fire({
                    title: `<strong>${ response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                })
            }
            setLoadingLogs(false);
        })
        .catch(error => {
            setLoadingLogs(false)
            Swal.fire({
            title: `<strong>"Failed"</strong>`,
            text: error?.data?.message,
            icon: 'error',
            showConfirmButton: true,
            allowOutsideClick: false
            })
        });
}

useEffect(() => {
    getUser();
    getList();
    getFnfSettings();
}, []);
// useEffect(() => {
//     if(isChanged){
//         ;
//     }
// }, [isChanged]);

const templatePreview = (templateType) => {
    // console.log("allowances",allowances)
    setFormData({
        ...formData,
        mailSubject: `Resignation Of ${employeeBasicData?.employee_name || ''} ${employeeBasicData?.employee_code?`(${employeeBasicData?.employee_code})`:''}`
    });
    const replaceCheatCodeList = [
      { cheat_code: "##employee_name##", value: `${employeeBasicData?.employee_title || ''} ${employeeBasicData?.employee_name || ''}` },
      { cheat_code: "##employee_code##", value: `${employeeBasicData?.employee_code || ''}` },
      {
        cheat_code: "##department_title##",
        value: employeeBasicData?.department_title,
      },
      {
        cheat_code: "##designation##",
        value: employeeBasicData?.designation_title || '',
      },
    //   { cheat_code: "##grade_title##", value: employeeBasicData?.candidateGrade },
      { cheat_code: "##location_title##", value: employeeBasicData?.location_title },
      {
        cheat_code: "##employee_joining_date##",
        value: formatDate(employeeBasicData?.employee_joining_date),
      },
    ];
    if (templateType === "email") {
      let email = previewTemplate(
        formData.mailBody,
        replaceCheatCodeList
      );
      setFormData({
        ...formData,
        mailBody: email
      });
      setEditorContent(email);
    }
  };

  const previewTemplate = (inputString, cheatCodeArray) => {
    if (!inputString || !cheatCodeArray || !Array.isArray(cheatCodeArray)) {
      throw new Error(
        "Invalid input: Provide a valid string and cheatCodeArray"
      );
    }

    return cheatCodeArray.reduce((updatedString, { cheat_code, value }) => {
      if (cheat_code && value) {
        const regex = new RegExp(cheat_code, "g"); // Use 'g' flag for global replacement
        return updatedString.replace(regex, value);
      }
      return updatedString;
    }, inputString);
  };

//   const handleEditorChange = (event, editor) => {
//     const mailContent = editor.getData();
//     console.log(mailContent);
//     // Clear the previous timeout if the user is still typing
//     if (debounceTimerRef.current) {
//       clearTimeout(debounceTimerRef.current);
//     }
  
//     // Set a new timeout to call the function after 1 second
//     debounceTimerRef.current = setTimeout(() => {
//       setFormData(prevState => ({
//         ...prevState,
//         mailBody: mailContent
//       }));
//       // Call the content change handler
//       // handleContentChange(mailContent);
//     }, 1000);
  
//     setErrors(prevErrors => ({
//       ...prevErrors,
//       mailBody: ''
//     }));
//   };

// const handleEditorChange = (content) => {
//     console.log(content);
    
//     // Clear the previous timeout if the user is still typing
//     if (debounceTimerRef.current) {
//       clearTimeout(debounceTimerRef.current);
//     }
  
//     // Set a new timeout to call the function after 1 second
//     debounceTimerRef.current = setTimeout(() => {
//       setFormData(prevState => ({
//         ...prevState,
//         mailBody: content
//       }));
//     }, 1000);
  
//     setErrors(prevErrors => ({
//       ...prevErrors,
//       mailBody: ''
//     }));
//   };


  
  const getInfo = (row) => {

    let newState = {
        fileName: row?.email_attachments,
        fileSize: "",
        errorMessage: errors?.file,
        fileDelete:false,
    };

    if (row?.email_attachments && row?.email_attachments.includes("pdf")) {
        newState = {
            ...newState,
            isValidPdfFile: true,
            fileTypeIcon: "/img/pdf-logo.svg",
        };
    } else {
        newState = {
            ...newState,
            // selectedImage: URL.createObjectURL(file),
            fileTypeIcon: "/img/img-logo.png",
        };
    }
    setFormData({
        ...formData,
        mailBody: row?.email_body,
        mailSubject: row?.email_subject,
        file:row?.document_url,
        fileData:newState,
        requestedRelievingDate: row?.request_last_working_date,
    });
    setEditorContent(row?.email_body);
    setFnfSettings({
        ...fnfSettings,
        notice_period_duration:row?.notice_period,
        last_working_date: row?.last_working_date,
    })
    setModals({ ...modals, applyModal: true })
    setCanSend(false);
  }

//   useEffect(() => {
//     if (mail_id) {
//       getInfo();
//     }
//   }, []);

//   const handleSubmit = e => {
//     e.preventDefault()

//     const errors = validateForm()
//     console.error('Create Mail Error', errors)
//     if (Object.keys(errors).length > 0) {
//       setErrors(errors)
//       return
//     }
//     setLoading(true)
//     const data = {
//         email_body: formData?.mailBody,
//         requested_relieving_date: formData?.requestedRelievingDate || "",
//         email_subject: formData?.mailSubject,
//         file: formData?.file || "",
//         date: currentDateAndTime()
//     }

//     const headers = apiHeaderFile
//     // setLoading(true);
//     axios
//       .post(`${apiURL}ResignationRouter/CreateMyResignation`, data, {
//         headers
//       })
//       .then(response => {
//         const { success } = response.data
//         if (success === true) {
//           setModals({
//             ...modals,
//             applyModal:false,
//           })
//           setFormData({
//             mailSubject: 'Resignation',
//             mailBody: `<p>Dear Sir,</p><p>&nbsp;</p><p>I hope this message finds you well.</p><p>&nbsp;</p>
//             <p>I am writing to formally resign from my position as <strong>##designation##</strong> 
//             (Employee ID: <strong>##employee_code##</strong>).</p><p>It has been a pleasure working 
//             with the team, and I am grateful for the support and opportunities provided during my tenure.</p>
//             <p>Please let me know if there are any formalities or handover processes I need to complete before 
//             my departure.</p><p>Thank you for your understanding and guidance.</p><p>&nbsp;</p><p>Best regards,
//             <br><strong>##employee_name##</strong></p>`,
//             file:null,
//             fileData:null,
//           });
//           getList();
//         } 
//         Swal.fire({
//             title: `<strong>${ response.data.success === true ? 'Success' : 'Failed'}</strong>`,
//             text: response.data.message,
//             icon: response.data.success === true ? 'success' : 'error',
//             showConfirmButton: true,
//             allowOutsideClick: false
//           })
//         setLoading(false)
//       })
//       .catch(error => {
//         setLoading(false)
//         Swal.fire({
//           title: `<strong>"Failed"</strong>`,
//           text: error?.data?.message,
//           icon: 'error',
//           showConfirmButton: true,
//           allowOutsideClick: false
//         })
//       })
//   }
const handleSubmit = e => {
    e.preventDefault();
  
    const errors = validateForm();
    console.error('Create Mail Error', errors);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
  
    setLoading(true);
    const data = {
      email_body: formData?.mailBody,
      requested_relieving_date: formData?.requestedRelievingDate || "",
      email_subject: formData?.mailSubject,
      file: formData?.file || "",
      date: currentDateAndTime()
    };
  
    const headers = apiHeaderFile;
  
    axios
      .post(`${apiURL}ResignationRouter/CreateMyResignation`, data, { headers })
      .then(response => {
        const { success, message } = response.data;
  
        Swal.fire({
          title: `<strong>${success ? 'Success' : 'Failed'}</strong>`,
          text: message,
          icon: success ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        });
  
        if (success) {
          setModals(prev => ({ ...prev, applyModal: false }));
  
          setFormData({
            mailSubject: 'Resignation',
            mailBody: `<p>Dear Sir,</p><p>&nbsp;</p><p>I hope this message finds you well.</p><p>&nbsp;</p>
            <p>I am writing to formally resign from my position as <strong>##designation##</strong> 
            (Employee ID: <strong>##employee_code##</strong>).</p><p>It has been a pleasure working 
            with the team, and I am grateful for the support and opportunities provided during my tenure.</p>
            <p>Please let me know if there are any formalities or handover processes I need to complete before 
            my departure.</p><p>Thank you for your understanding and guidance.</p><p>&nbsp;</p><p>Best regards,
            <br><strong>##employee_name##</strong></p>`,
            file: null,
            fileData: null
          });
  
          getList();
        }
  
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        const errorMessage =
          error?.response?.data?.message || "Something went wrong. Please try again.";
        Swal.fire({
          title: `<strong>Failed</strong>`,
          text: errorMessage,
          icon: 'error',
          showConfirmButton: true,
          allowOutsideClick: false
        });
      });
  };
  
  const handleCancel = (e,row) => {
    e.preventDefault()

   
    const headers = apiHeaderJSON
    // setLoading(true);
    Swal.fire({
        title: 'Are you sure?',
        text: "You want to cancel this resignation?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No!',
        input: 'textarea', 
        inputPlaceholder: 'Enter your remark here...',
        inputAttributes: {
            'aria-label': 'Enter your remark here...', 
        },
        allowOutsideClick:false,
        preConfirm: (remark) => {
            if (!remark) {
                Swal.showValidationMessage('Remark cannot be empty');
            }
            return remark;
        }
    }).then((result) => {
        if (result.isConfirmed && result.value) {
            setLoading(`${row?.employee_resignation_id}`);
            const data = {
                employee_resignation_id:row?.employee_resignation_id,
                remarks: result.value,
                date: currentDateAndTime()
            }
            axios
            .post(`${apiURL}ResignationRouter/CancelResignation`, data, {
                headers
            })
            .then(response => {
                const { success } = response.data
                if (success === true) {
                
                getList();
                } 
                Swal.fire({
                    title: `<strong>${ response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false
                })
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                Swal.fire({
                title: `<strong>"Failed"</strong>`,
                text: error?.data?.message,
                icon: 'error',
                showConfirmButton: true,
                allowOutsideClick: false
                })
            })
        }
    });
  
  }

  const validateForm = () => {
    const errors = {}
    // if (!formData?.mailTemplateTitle) {
    //   errors.mailTemplateTitle = 'Mail template title is required!'
    // }
    // if (!formData?.mailSubject) {
    //   errors.mailSubject = 'Mail subject is required!'
    // }
    if (!formData?.mailBody) {
      errors.mailBody = 'Email Body is can not be empty!'
    }
    // console.log(formData?.mailBody);
    return errors
  }
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const errors={};
    // console.log(file);
    if (file) {
        const { name, size, type } = file;
        const fileSizeInMB = size / (1024 * 1024);
        // console.log("size",size / (1024 * 1024));
        errors.required_document = '';
        if (fileSizeInMB > 10) {
            errors.file= "File size exceeds the maximum limit of 10 MB";
            setErrors({
                ...errors,
                file:"File size exceeds the maximum limit of 10 MB"
            });
            console.error("File size exceeds the maximum limit of 10 MB");
            return;
        }
        let newState = {
            fileName: name,
            fileSize: `${fileSizeInMB.toFixed(2)} MB`,
            letterhead: [file],
            errorMessage: errors?.file,
            fileDelete:true
        };

        if (type.startsWith("image/")) {
            newState = {
                ...newState,
                selectedImage: URL.createObjectURL(file),
                fileTypeIcon: "/img/img-logo.png",
            };
        } else {
            newState = {
                ...newState,
                isValidPdfFile: true,
                fileTypeIcon: "/img/pdf-logo.svg",
            };
        }
        // console.log(file,newState,);
        setErrors({
            ...errors,
            file:""
        });
        setFormData({
            ...formData,
            file:file,
            fileData:newState,
        });

    }
};
const handleDeleteImage=()=>{
    setFormData({
        ...formData,
        file:null,
        fileData:null,
    })
}
const addDaysToDate = (startDate, days) => {
    let resultDate = new Date(startDate);
    resultDate.setDate(resultDate.getDate() + parseInt(days)); // Add the number of days
    resultDate= formatDate(resultDate)
    return resultDate; // Return in YYYY-MM-DD format
}
//   const handleCopyClick = (code) => {
//     copy(code);
//     toast.success(`Key Has Been Copied! ${code}`, { autoClose: 1500 });
//   };


  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid mt-3'>
          <PageTitle title={'Resignation'} primary={`Home`} />     
            {/* <div
            className="offcanvas offcanvas-end"
            tabIndex={-1}
            id="offcanvasRight"
            aria-labelledby="offcanvasRightLabel"
            >
                <div className="offcanvas-header">
                    <h5 id="offcanvasRightLabel"> Placeholder Keys</h5>
                    <button
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    />
                </div>
                <div className="offcanvas-body">
                    <table class="table table-hover table-bordered border-primary table-nowrap">
                        <thead className="bg-primary text-light bg-gradient">
                            <tr>
                            <th scope="col">Names</th>
                            <th scope="col">Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                            masterCheatCode?.map((val)=>{
                                return (
                                <tr>
                                    <td>{val?.name}</td>
                                    <td onClick={() => handleCopyClick(val?.code)} style={{ cursor: "pointer" }}>{val?.code}</td>
                                </tr>
                                )
                            })
                            }
                        </tbody>
                    </table>
                </div>
            </div> */}
        {!modals?.applyModal && (   
            <div className='card'>
                <div className='card-header align-items-center d-flex'>
                        <h4 className='card-title mb-0 flex-grow-1'>
                            {/* {company_salary_head_id ? "Update Payroll Head" : "Create Payroll Head"} */}
                            {'Resignation Mail'}
                        </h4>
                        { decodedData?.includes(2) && ( 
                        <div className=' d-flex align-items-center gap-2'>
                            <button type="button" className="btn btn-secondary noWrap waves-effect waves-light btn-label"
                            disabled={loading || !applyButton}
                            onClick={()=> {templatePreview('email'); 
                                setCanSend(true); 
                                getFnfSettings(); 
                                setModals({ ...modals, applyModal: true })}}
                            >
                            <i className=" ri-mail-line label-icon align-middle fs-16 ms-2" />{" "}
                            <span className='d-flex align-items-center gap-2'>Apply <span className=' d-md-block d-none'>Resignation</span></span>
                            </button>
                            {/* <NavLink className='btn btn-success btn-sm py-2' to={`/EmailTemplateList`}>
                                <i className='bx bx-list-ul label-icon align-middle fs-4 ' />
                            </NavLink> */}
                        </div>)}
                </div>
                <div>
                    <div className='grid grid-md-2 gap-4 p-md-3 p-2'>
                        {Array.isArray(rows) && rows?.map((row)=>{
                            return(
                                <div className=' borderGray rounded-3 p-4'>
                                    <div className=' mb-2 textGray d-flex justify-content-between align-items-center gap-1'>
                                        {/* <div className=' textGray d-flex align-items-center gap-1'> */}
                                            <h6 className='mb-0 text-dark'>Application Date: <span className=' textGray'>{row?.resignation_date? formatDateWithTime(row?.resignation_date):'--'}</span></h6> 
                                        {/* </div> */}
                                        <div className={`badge bg-${row?.ResignationStatusClasses}`}>
                                            {row?.ResignationStatus || '--'}
                                        </div>
                                    </div>
                                    <div>
                                        <h6>{row?.email_subject || "--"}</h6>

                                        {/* <p>{row?.mailBody || "No Mail Found!"}</p> */}
                                    </div>
                                    <div className=' d-flex justify-content-between align-items-center gap-2'>
                                        <div>
                                        <button
                                        type="button"
                                        className="btn btn-success py-1 waves-effect waves-light"
                                        onClick={()=> {getInfo(row)}}
                                        >
                                            View
                                        </button>
                                        {loadingLogs==row?.employee_resignation_id?
                                            <button className="btn btn-info ms-2 btn-load">
                                                <span className="d-flex align-items-center">
                                                <span
                                                    class="spinner-border flex-shrink-0"
                                                    role="status"
                                                    style={{
                                                    width: "0.8rem",
                                                    height: "0.8rem",
                                                    borderWidth: "2px",
                                                    }}
                                                >
                                                    <span class="visually-hidden">Loading...</span>
                                                </span>
                                                </span>
                                            </button>:
                                            <button
                                                type="button"
                                                className="btn btn-info ms-2 py-1 waves-effect waves-light"
                                                onClick={()=> { setLoadingLogs(`${row?.employee_resignation_id}`); getLogs(row)}}
                                                >
                                                Logs
                                            </button>
                                        }
                                        </div>
                                        
                                        {loading==row?.employee_resignation_id?
                                            <button className="btn btn-primary btn-load">
                                                <span className="d-flex align-items-center">
                                                <span
                                                    class="spinner-border flex-shrink-0"
                                                    role="status"
                                                    style={{
                                                    width: "0.8rem",
                                                    height: "0.8rem",
                                                    borderWidth: "2px",
                                                    }}
                                                >
                                                    <span class="visually-hidden">Loading...</span>
                                                </span>
                                                </span>
                                            </button>:
                                            row?.ResignationStatus==="Applied" || row?.ResignationStatus==="On Hold"? 
                                            <button
                                            type="button"
                                            className="btn btn-secondary py-1 waves-effect waves-light"
                                            onClick={(e)=> { 
                                                handleCancel(e,row)
                                                // setFormData({
                                                //     ...formData,
                                                //     // mailSubject: '',
                                                //     mailSubject: `Resignation Of ${employeeBasicData?.employee_name || ''} ${employeeBasicData?.employee_code?`(${employeeBasicData?.employee_code})`:''}`,
                                                //     mailBody: ``,
                                                //     file:null,
                                                //     fileData:null,
                                                // })
                                                // setModals({ ...modals, applyModal: true })
                                            }}
                                            >
                                                Cancel Resignation
                                            </button>:null
                                        }
                                        {/* <NavLink className='btn btn-success btn-sm py-2' to={`/EmailTemplateList`}>
                                            <i className='bx bx-list-ul label-icon align-middle fs-4 ' />
                                        </NavLink> */}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        )}
        {modals?.applyModal && (
            <div className='card'>
                <div className='card-header align-items-center d-flex'>
                    <h4 className='card-title mb-0 flex-grow-1'>
                        {/* {company_salary_head_id ? "Update Payroll Head" : "Create Payroll Head"} */}
                        {'Resignation Mail'}
                    </h4>
                    <div className=' d-flex align-items-center gap-2'>
                        <button
                        type="button"
                        className="btn btn-danger waves-effect waves-light btn-label"
                        onClick={()=> {
                            setCanSend(true);
                            setFormData({
                                mailSubject: 'Resignation',
                                mailBody: `<p>Dear Sir,</p><p>&nbsp;</p><p>I hope this message finds you well.</p><p>&nbsp;</p>
                                <p>I am writing to formally resign from my position as <strong>##designation##</strong> 
                                (Employee ID: <strong>##employee_code##</strong>).</p><p>It has been a pleasure working 
                                with the team, and I am grateful for the support and opportunities provided during my tenure.</p>
                                <p>Please let me know if there are any formalities or handover processes I need to complete before 
                                my departure.</p><p>Thank you for your understanding and guidance.</p><p>&nbsp;</p><p>Best regards,
                                <br><strong>##employee_name##</strong></p>`,
                                file:null,
                                fileData:null,
                                requestedRelievingDate: "",
                            });
                            // setFnfSettings({});
                            setModals({ ...modals, applyModal: false })}}
                        disabled={loading}
                        >
                        <i className="ri-close-line label-icon align-middle fs-16 ms-2" />{" "}
                        Close
                        </button>
                        {/* <NavLink className='btn btn-success btn-sm py-2' to={`/EmailTemplateList`}>
                            <i className='bx bx-list-ul label-icon align-middle fs-4 ' />
                        </NavLink> */}
                    </div>
                </div>
                <div className='card-body'>
                    <form onSubmit={handleSubmit}>
                        <div className='row gy-4'>
                            <div className='col-md-6 mb-3 mt-3'>
                                <label htmlFor='mailSubject' className='form-label'>
                                Subject:
                                </label>
                                <input
                                type='text'
                                id='mailSubject'
                                name='mailSubject'
                                disabled
                                value={formData?.mailSubject}
                                // onChange={e =>
                                //     handleInputChange('mailSubject', e.target.value)
                                // }
                                className={`form-control ${
                                    errors.mailSubject ? 'is-invalid' : ''
                                }`}
                                placeholder='Enter Subject'
                                />

                                {errors.mailSubject && (
                                <div className='invalid-feedback'>
                                    {errors.mailSubject}
                                </div>
                                )}
                            </div>
                            <div className='col-md-3 mb-3 mt-3'>
                                <label htmlFor='notice_period_duration' className='form-label'>
                                Notice Period:
                                </label>
                                <input
                                type='text'
                                id='notice_period_duration'
                                name='notice_period_duration'
                                disabled
                                value={`${fnfSettings?.notice_period_duration || 0} Days`}
                                // onChange={e =>
                                //     handleInputChange('notice_period_duration', e.target.value)
                                // }
                                className={`form-control`}
                                placeholder=''
                                />
                            </div>
                            <div className='col-md-3 mb-3 mt-3'>
                                <label htmlFor='relieving_date' className='form-label'>
                                Official Relieving Date:
                                </label>
                                <input
                                type='text'
                                id='relieving_date'
                                name='relieving_date'
                                disabled
                                value={ fnfSettings?.last_working_date? formatDate(fnfSettings?.last_working_date): fnfSettings?.notice_period_duration && fnfSettings?.notice_period_duration!="0"? addDaysToDate(currentDateAndTime(),fnfSettings?.notice_period_duration):"None"}
                                // onChange={e =>
                                //     handleInputChange('relieving_date', e.target.value)
                                // }
                                className={`form-control`}
                                placeholder=''
                                />
                            </div>
                            <div className='col-md-6 mb-3 mt-3'>             
                                <label className="form-label">Attachment <span className='text-muted '>{canSend?'(...Optional)':" (Not Uploaded!)"}</span></label>
                                <div>
                                    <input
                                        type="file"
                                        id="employee_resignation_document"
                                      
                                        onChange={handleFileChange}
                                        style={{ marginTop: "10px", display: "none" }}
                                        accept="image/jpeg, image/png, application/pdf"
                                        // disabled={check_modal_type === 2}
                                    />
                                    {canSend && !formData.fileData?.fileName && (
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <label
                                                    type="submit"
                                                    className="btn btn-primary btn-label waves-effect waves-light"
                                                    style={{ marginTop: "10px" }}
                                                    htmlFor="employee_resignation_document"
                                                    // disabled={check_modal_type === 2}
                                                >
                                                    <i className="ri-file-line label-icon align-middle fs-16 me-2" />
                                                    Choose File
                                                </label>
                                                {errors.file && <div className="text-danger">{errors.file}</div>}
                                            </div>
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        id="employee_resignation_document"
                                       
                                        onChange={handleFileChange}
                                        style={{ marginTop: "10px", display: "none" }}
                                        accept="image/jpeg, image/png, application/pdf"
                                    />
                                    <ul
                                        className="list-unstyled mb-0"
                                        id="dropzone-preview"
                                        style={{ display: !formData.file ? "none" : "block", }}>
                                        <li className="mt-2 dz-processing dz-error dz-complete"
                                            id="dropzone-preview-list">
                                            <div className="border rounded">
                                                <div className="d-flex p-2">
                                                    <div onClick={()=>{
                                                        if(!formData.fileData?.fileDelete && formData?.file){
                                                            setModals({
                                                                ...modals,
                                                                viewDocument:true
                                                            });
                                                        }
                                                    }} className={`${!formData.fileData?.fileDelete && formData?.file? "cursorPointer":''} flex-shrink-0 me-3`}>
                                                        <div className="avatar-sm bg-light rounded d-flex align-items-center justify-content-center">
                                                            {/* <i className={formData.fileData?.fileTypeIcon} style={{ position: "absolute", color: "green", marginLeft: "12px", marginTop: "5px", fontSize: "25px" }}></i> */}
                                                            <img style={{ width:"20px"}} src={formData.fileData?.fileTypeIcon} alt="pdf" />
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <div className="pt-1">
                                                            <h5
                                                                className="fs-13 mb-1"
                                                                data-dz-name=""
                                                            >
                                                                {formData.fileData?.fileName}
                                                            </h5>
                                                            <p
                                                                className="fs-13 text-muted mb-0"
                                                                data-dz-size=""
                                                            >
                                                                <strong>{formData.fileData?.fileSize}</strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {formData.fileData?.fileDelete && (
                                                        <div className="flex-shrink-0 ms-3 d-flex justify-content-center align-items-center">
                                                            <button
                                                                type='button'
                                                                data-dz-remove=""
                                                                onClick={handleDeleteImage}
                                                                className="btn btn-sm btn-outline-danger"
                                                            >
                                                                <i className="ri-delete-bin-line"></i>
                                                            </button>
                                                        </div>
                                                    )}
                                                    
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                         
                            </div>
                            {canSend?
                            (
                                <div className='col-md-6 mb-3 mt-3'>             
                                {/* <label className="form-label">Attachment <span className='text-muted '>{canSend?'(...Optional)':" (Not Uploaded!)"}</span></label> */}
                                <TextBox
                                type="Date"
                                id="requestedRelievingDate"
                                name="requestedRelievingDate"
                                label={`Requested Relieving Date: (Optional)`}
                                value={formData.requestedRelievingDate}
                                change={(e)=> handleInputChange('requestedRelievingDate', e.target.value)}
                                />
                            </div>
                            ):
                            (
                            <div className='col-md-6 mb-3 mt-3'>
                                <label htmlFor='relieving_date' className='form-label'>
                                    Requested Relieving Date:
                                </label>
                                <input
                                    type='text'
                                    id='relieving_date'
                                    name='relieving_date'
                                    disabled
                                    value={ formData.requestedRelievingDate? formatDate(formData.requestedRelievingDate): ""}
                                    // onChange={e =>
                                    //     handleInputChange('relieving_date', e.target.value)
                                    // }
                                    className={`form-control`}
                                    placeholder=''
                                />
                            </div>
                            )}
                           
                        </div>
                        <div className='col-md-12 card-body p-md-3 p-0'>
                            {canSend ? (
                            <>
                                {/* <CKEditor
                                    editor={ClassicEditor}
                                    data={formData?.mailBody}
                                    name={'mailBody'}
                                    disabled={!canSend}
                                    onChange={handleEditorChange}
                                /> */}
                               
                               <ReactQuill
                                value={editorContent}
                                onChange={handleEditorChange}
                                readOnly={!canSend}
                                theme="snow"
                                />
                                {errors.mailBody && (
                                    <div style={{ fontSize: '12px' }} className=' text-danger'>
                                    {errors.mailBody}
                                    </div>
                                )}
                                <div style={{ marginTop: '30px', marginLeft: 'Auto' }}>
                                    {!loading?
                                    <button
                                    disabled={loading}
                                    type='submit'
                                    className={`btn btn-primary btn-label waves-effect  waves-light float-right`}
                                    >
                                    <i
                                        className={`ri-mail-send-line label-icon align-middle fs-16 ms-2`}
                                    />
                                    {'Send'}
                                    </button>:
                                    <button className="btn btn-primary btn-load">
                                        <span className="d-flex align-items-center">
                                            <span className="spinner-border flex-shrink-0" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </span>
                                            <span className="flex-grow-1 ms-2">
                                            Sending...
                                            </span>
                                        </span>
                                    </button>
                                    }
                                </div>
                            </>) : 
                            (
                                <div className=' card-body border-1 rounded-3 bg-light'
                                dangerouslySetInnerHTML={{ __html: formData?.mailBody ? formData?.mailBody : "", }}/>
                            )}
                        </div>
                    </form>
                </div>
          </div>
        )}
        
        {modals?.viewDocument && (
            <div id="myModal" className="modal show"  tabIndex={-1} style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}
            aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="m-auto mt-3 w-modal">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="myModalLabel">Attachment</h5>
                        <button onClick={() => { setModals({...modals,viewDocument:false,})}}
                        className="btn-close" aria-label="Close"/>
                    </div>
                    <div className="modal-body">
                    <div className="row">
                        <div className="mb-4 m-auto p-1 rounded-2 grayBlurShadow">
                        <h3 className="text-center text-ellipse">
                            {formData?.fileData?.fileName || "--"}
                        </h3>
                        <div className="m-auto rounded-3 overflow-hidden" style={{ width: "100%", height: "600px", border: "1px solid #ccc", }}>
                            {formData?.file && formData?.file?.includes("pdf") ? (
                            <iframe
                                src={formData?.file}
                                title="PDF Viewer"
                                style={{
                                width: "100%",
                                height: "100%",
                                }}
                                frameBorder="0"
                            >
                                This browser does not support embedded
                                files.
                            </iframe>
                            ) : (
                            formData?.file?
                            <img
                                src={formData?.file}
                                style={{
                                width: "100%",
                                // height: "100%",
                                }}
                                alt="document_image"
                            />:
                            <p>Attachment Not Found!</p>
                            )}
                        </div>
                        </div>
                    </div>
                    </div>
                    {/* <div className="modal-footer">
                    <button
                        onClick={() => {
                        this.setState({
                            viewDocument: false,
                            doc_title: "",
                            doc_url: "",
                        });
                        }}
                        className="btn btn-light"
                    >
                        Close
                    </button>
                    </div> */}
                </div>
                </div>
            </div>
        )}
        {viewResignationLogs && (
            <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}  >
            <div className="modal-dialog modal-xl"
                style={{ width: "90%" }}>
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title pb-2" id="rmModalLabel">Resignation Logs</h5>
                    <button type="button" className="btn-close" onClick={()=> {
                        setFormData({
                            mailSubject: 'Resignation',
                            mailBody: `<p>Dear Sir,</p><p>&nbsp;</p><p>I hope this message finds you well.</p><p>&nbsp;</p>
                            <p>I am writing to formally resign from my position as <strong>##designation##</strong> 
                            (Employee ID: <strong>##employee_code##</strong>).</p><p>It has been a pleasure working 
                            with the team, and I am grateful for the support and opportunities provided during my tenure.</p>
                            <p>Please let me know if there are any formalities or handover processes I need to complete before 
                            my departure.</p><p>Thank you for your understanding and guidance.</p><p>&nbsp;</p><p>Best regards,
                            <br><strong>##employee_name##</strong></p>`,
                            file:null,
                            fileData:null,
                            requestedRelievingDate: "",
                        });
                        // setFnfSettings({});
                        setViewResignationLogs(false);
                    }} aria-label="Close" />
                </div>
                <div className="modal-body">
                    {/* <h5>Subject: {Array.isArray(logRows) && logRows.length > 0 ? logRows[0]?.email_subject: "--"}</h5> */}
                    <div className='row gy-4'>
                        <div className='col-md-6 mb-3 mt-0 '>
                            <label htmlFor='mailSubject' className='form-label'>
                            Subject:
                            </label>
                            <input type='text' id='mailSubject' name='mailSubject' disabled value={formData?.mailSubject}
                            // onChange={e =>
                            //     handleInputChange('mailSubject', e.target.value)
                            // }
                            className={`form-control ${ errors.mailSubject ? 'is-invalid' : ''}`} placeholder='Enter Subject'/>
                            {errors.mailSubject && (<div className='invalid-feedback'>{errors.mailSubject}</div>)}
                        </div>
                        <div className='col-md-6 mb-3 mt-0'>
                            <label htmlFor='notice_period_duration' className='form-label'>Notice Period:</label>
                            <input type='text' id='notice_period_duration' name='notice_period_duration' disabled value={`${fnfSettings?.notice_period_duration || 0} Days`}
                            // onChange={e =>
                            //     handleInputChange('notice_period_duration', e.target.value)
                            // }
                            className={`form-control`} placeholder=''/>
                        </div>
                        <div className='col-md-6 mb-3 mt-0'>
                            <label htmlFor='relieving_date' className='form-label'>
                            Official Relieving Date:
                            </label>
                            <input
                            type='text'
                            id='relieving_date'
                            name='relieving_date'
                            disabled
                            value={ fnfSettings?.last_working_date && fnfSettings?.last_working_date!="0" ? formatDate(fnfSettings?.last_working_date): "None"}
                            // onChange={e =>
                            //     handleInputChange('relieving_date', e.target.value)
                            // }
                            className={`form-control`}
                            placeholder=''
                            />
                        </div>
                        {formData.requestedRelievingDate && formData.requestedRelievingDate!="0" && (
                            <div className='col-md-6 mb-3 mt-0'>
                                <label htmlFor='relieving_date' className='form-label'>
                                    Requested Relieving Date:
                                </label>
                                <input
                                    type='text'
                                    id='relieving_date'
                                    name='relieving_date'
                                    disabled
                                    value={ formData.requestedRelievingDate && formData.requestedRelievingDate!="0"? formatDate(formData.requestedRelievingDate): "--"}
                                    // onChange={e =>
                                    //     handleInputChange('relieving_date', e.target.value)
                                    // }
                                    className={`form-control`}
                                    placeholder=''
                                />
                            </div>
                        )}
                        
                    </div>
                    <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                        <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                            <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                <tr>
                                    <th style={{ width:"5%"}} className="text-center">Sr.No.</th>
                                    <th style={{ width:"8%"}} className="text-center noWrap">Resignation Date</th>
                                    {/* <th className="text-center">Subject</th> */}
                                    <th style={{ width:"10%"}} className="text-center">Status</th>
                                    {/* <th style={{ width:"15%"}} className="text-center">Requested Date</th> */}
                                    <th className='noWrap'>Employee Remarks</th>
                                    <th className='noWrap' >RM Remarks</th>
                                    
                                </tr>
                            </thead>
                            {Array.isArray(logRows) && logRows.length === 0 ? (
                                <tbody>
                                <tr>
                                    <td colSpan={11}>
                                    <NoRecords />
                                    </td>
                                </tr>
                                </tbody>
                            ) :
                                <tbody>
                                {Array.isArray(logRows) && logRows.map((row,idx) => {
                                    return (
                                    <tr key={row.employee_id}>
                                        <td className="text-center">{idx+1}</td>
                                        <td className="noWrap text-center">{row.resignation_date? formatDate(row.resignation_date):"--"}</td>
                                        {/* <td>{row.goal_title}</td> */}
                                        <td>
                                            <div
                                                style={{ fontSize: "0.65rem" }}
                                                className={`noWrap bg-${row?.ResignationStatusClasses} text-white fw-semibold px-1 text-center py-1  rounded-4`}
                                            >
                                                {row?.ResignationStatus}
                                            </div>
                                        </td>
                                        {/* <td className={`"text-center`} >{row?.request_last_working_date ? formatDate(row?.request_last_working_date) : "--" }</td> */}
                                        <td className={`${row?.employee_remarks? "":"text-center"}`} >{row?.employee_remarks || "--"}</td>
                                        <td className={`${row?.rm_remarks? "":"text-center"}`} >{row?.rm_remarks || "--"}</td>
                                    </tr>
                                    );
                                })}
                                </tbody>}
                                {/* <tfoot className="table-light">
                                    <tr>
                                    <th colSpan={8}>
                                        <div className="d-flex justify-content-between">
                                        <button
                                            disabled={
                                            prev === false &&
                                                loadingList === false
                                                ? true
                                                : false
                                            }
                                            type="button"
                                            onClick={() => this.handlePrev()}
                                            className={`btn btn-warning btn-label waves-effect waves-light`}
                                        >
                                            <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                            Previous
                                        </button>
                                        <div
                                            className="col-md-4"
                                            style={{ display: "flex", alignItems: "center" }}
                                        >
                                            {
                                            <small>
                                                Total Records: {total_records} |
                                                Total Pages: {total_pages} |
                                                Current Page: {page}
                                            </small>
                                            }
                                        </div>
                                        <div className="col-md-2">
                                            <select
                                            className="form-select"
                                            onChange={(e) => this.handleChange(e)}
                                            >
                                            {Array.from(
                                                { length: total_pages },
                                                (_, i) => (
                                                <option
                                                    selected={page === i + 1}
                                                    key={i}
                                                    value={i + 1}
                                                >
                                                    Page {i + 1}
                                                </option>
                                                )
                                            )}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <select
                                            className="form-select"
                                            onChange={this.handleLimitChange}
                                            value={limit}
                                            >
                                            {limitOptions.map((option) => (
                                                <option key={option} value={option}>
                                                Limit {option}
                                                </option>
                                            ))}
                                            </select>
                                        </div>
                                        <button
                                            disabled={
                                            next === false &&
                                                loadingList === false
                                                ? true
                                                : false
                                            }
                                            type="button"
                                            onClick={() => this.handleNext()}
                                            className={`btn btn-primary btn-label waves-effect right waves-light`}
                                        >
                                            <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                            Next
                                        </button>
                                        </div>
                                    </th>
                                    </tr>
                                </tfoot> */}
                        </table>
                    </div>
                </div>
                </div>
            </div>
            </div>
        )}
        </div>
      </div>
    </div>
  )
}

export default Resignation
